import { render } from "./load-for-campaign-creation.vue?vue&type=template&id=1bb8db02&ts=true"
import script from "./load-for-campaign-creation.ts?vue&type=script&lang=ts&external"
export * from "./load-for-campaign-creation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__